module.exports = __webpack_public_path__ + "img/u574.cc2c15a7.svg";